import styled from 'styled-components'

import { HeadingL, BodyBold, Body, SmallText } from '../../../component-library/design/typography/typography.styles'
import { COLOR } from '../../../component-library/design/color/color.constants'
import { SPACING } from '../../../component-library/design/spacing/spacing.constants'
import { BREAKPOINT } from '../../../design/breakpoint.constant'

const Container = styled.div`
  width: 160px;
  display: inline-block;
  margin-bottom: ${SPACING.S};
  margin-top: ${SPACING.L};
  @media screen and (min-width: ${BREAKPOINT.TABLET}) {
    width:  ${props => props.numberOfVehicles === 4 ? "50%" : "33%"};
    max-width: 262px;
    margin-bottom: ${SPACING.XL};
  }
`

const Image = styled.img`
  width: 100%;
  max-width: 200px;
  margin-bottom: ${SPACING.S};
`

const Name = styled(BodyBold)``

const Description = styled(Body)`
  margin-bottom: 0;
`

const Fee = styled(HeadingL)`
  margin-top: ${SPACING.XS};
  margin-bottom: 0;
  color: ${props => props.defaultFeeStyle ? COLOR.GREY_DARK : COLOR.BLACK};
`

const LoaderWrapper = styled.div`
  margin-top: ${SPACING.XS};
  margin-bottom: ${SPACING.XS};
`

const FeeSubText = styled(SmallText)`
  margin: 0  0 0 0px ;
`

export { Container, Image, Name, Description, Fee, LoaderWrapper, FeeSubText }
